import React, { useMemo } from "react";
import CalendarNavigation from "./CalendarNavigation";
import CalendarGrid from "./CalendarGrid";

const CalendarMain = ({
  currentDate,
  monthNames,
  dayNames,
  days,
  eventTypes = [],
  selectedDates,
  vacationDates,
  dateRangeStart,
  dateRangeEnd,
  dateRangeMode,
  getEventsForDate,
  styles,
  screenSize,
  language,
  theme,
  t,
  handlePrevMonth,
  handleNextMonth,
  handleGoToToday,
  onDateClick,
  onEventClick,
  onSelectMonth,
  onShowMoreEvents,
}) => {
  // Everything visible this month, de-duplicated — feeds both the count under
  // the title and the legend, so the colours in the grid can be decoded
  // without opening an event.
  const { monthEventCount, legendTypes } = useMemo(() => {
    const seen = new Map();
    days
      .filter((d) => d.isCurrentMonth && d.date)
      .forEach((d) => {
        (getEventsForDate(d.date) || []).forEach((ev) => seen.set(ev.id, ev));
      });

    const typeIds = new Set([...seen.values()].map((ev) => ev.type));
    return {
      monthEventCount: seen.size,
      legendTypes: eventTypes.filter((type) => typeIds.has(type.id)),
    };
  }, [days, getEventsForDate, eventTypes]);

  return (
    <div id="calendar-export" style={styles.calendarMain}>
      <CalendarNavigation
        currentDate={currentDate}
        monthNames={monthNames}
        eventCount={monthEventCount}
        styles={styles}
        screenSize={screenSize}
        language={language}
        theme={theme}
        t={t}
        handlePrevMonth={handlePrevMonth}
        handleNextMonth={handleNextMonth}
        handleGoToToday={handleGoToToday}
        onSelectMonth={onSelectMonth}
      />

      <CalendarGrid
        days={days}
        dayNames={dayNames}
        selectedDates={selectedDates}
        vacationDates={vacationDates}
        dateRangeStart={dateRangeStart}
        dateRangeEnd={dateRangeEnd}
        dateRangeMode={dateRangeMode}
        getEventsForDate={getEventsForDate}
        styles={styles}
        screenSize={screenSize}
        language={language}
        t={t}
        onDateClick={onDateClick}
        onEventClick={onEventClick}
        onShowMoreEvents={onShowMoreEvents}
      />

      {legendTypes.length > 0 && (
        <div style={styles.calendarLegend}>
          {legendTypes.map((type) => (
            <span key={type.id} style={styles.calendarLegendItem}>
              <span
                style={{
                  width: "9px",
                  height: "9px",
                  borderRadius: "3px",
                  background: type.color,
                  display: "inline-block",
                  flexShrink: 0,
                }}
              />
              {type.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarMain;
